export const bonusAndCommisionQuestions: Record<string, any> = {
  commission: {
    labelKey: 'applicationForm.BONUS_AND_COMMISSIONS.hasCommission.label',
    booleanQuestionFormKey: 'hasCommission',
    explanationKey: 'applicationForm.BONUS_AND_COMMISSIONS.hasCommission.explanation',
    adornmentKey: 'common.everyYear',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  overtime: {
    labelKey: 'applicationForm.BONUS_AND_COMMISSIONS.hasOvertime.label',
    booleanQuestionFormKey: 'hasOvertime',
    adornmentKey: 'common.everyYear',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
  bonus: {
    labelKey: 'applicationForm.BONUS_AND_COMMISSIONS.hasBonus.label',
    booleanQuestionFormKey: 'hasBonus',
    adornmentKey: 'common.everyYear',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
};
